import { createFileRoute } from "@tanstack/react-router"
import HiddenTab from "~/components/product-management/tabs/HiddenTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/product-management/_layout/hidden")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Product Management Hidden")
  return <HiddenTab />
}
